var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M767.92 554.62H554.59v213.33c0 23.47-19.2 42.67-42.67 42.67s-42.67-19.2-42.67-42.67V554.62H255.92c-23.47 0-42.67-19.2-42.67-42.67s19.2-42.67 42.67-42.67h213.33V255.96c0-23.47 19.2-42.67 42.67-42.67s42.67 19.2 42.67 42.67v213.33h213.33c23.47 0 42.67 19.2 42.67 42.67s-19.2 42.67-42.67 42.67Z"
  })));
};
export default SvgAdd;